import type { NetworkPayload } from "../../../composites";

export const API = {
  editUserMetadata: (
    uuid: string,
    metadata: API.User["metadata"],
  ): NetworkPayload<{ metadata: API.User["metadata"] }> => {
    return {
      url: `users/${uuid}/metadata`,
      options: {
        method: "PUT",
        payload: { metadata },
        isJsonResponse: true,
      },
    };
  },

  acceptTransactionalSmsDisclosure: (): NetworkPayload => {
    return {
      url: "accept_transactional_sms/",
      options: {
        method: "POST",
        payload: {},
        isJsonResponse: false,
      },
    };
  },
};
